module.exports = __webpack_public_path__ + "static/media/sample-club-with-player-count.cb7ab50a.png";